import { render, staticRenderFns } from "./Data.vue?vue&type=template&id=5a537d50&scoped=true&"
import script from "./Data.vue?vue&type=script&lang=js&"
export * from "./Data.vue?vue&type=script&lang=js&"
import style0 from "./Data.vue?vue&type=style&index=0&id=5a537d50&scoped=true&lang=css&"
import style1 from "./Data.vue?vue&type=style&index=1&id=5a537d50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a537d50",
  null
  
)

export default component.exports